define([], function service() {
  'use strict';

  /**
   * It handles packing and unpacking request data.
   *
   * @function RiqApiFormatter
   * @return {{pack: jsonPackager.pack, unpack: jsonPackager.unpack}} formatted response
   */
  function RiqApiFormatter() {
    var jsonPackager = {
      /**
       * Pack data to request
       * @function pack
       * @param {Object} payload - data for packing
       * @return {Object} pack object
       * */
      pack: function pack(payload) {
        var headers = new Headers();
        var boundary = 'ReadingIqBoundary-' + Date.now();
        var args = JSON.stringify(payload.args);
        var token = payload.token || '';
        var deviceId = payload.deviceId || '';
        var makeBody = function makeBody(data) {
          var tokenPart =
            '--' +
            boundary +
            '\n' +
            'Content-Disposition: form-data; name="token"\n\n' +
            data.token +
            '\n';

          var deviceIdPart = deviceId
            ? '--' +
              boundary +
              '\n' +
              'Content-Disposition: form-data; name="device_id"\n\n' +
              data.deviceId +
              '\n'
            : '';

          var argumentPart =
            '--' +
            boundary +
            '\n' +
            'Content-Disposition: form-data; name="arguments"\n\n' +
            data.args +
            '\n';

          var platformPart =
            '--' +
            boundary +
            '\n' +
            'Content-Disposition: form-data; name="platform"\n\n' +
            'web' +
            '\n';

          return (
            tokenPart +
            argumentPart +
            deviceIdPart +
            platformPart +
            '--' +
            boundary +
            '--\n'
          );
        };
        var body = makeBody({
          token: token,
          deviceId: deviceId,
          args: args
        });
        headers.append('Accept', '*/*');
        headers.append(
          'Content-Type',
          'multipart/form-data; boundary=' + boundary
        );
        return {
          method: 'POST',
          headers: headers,
          body: body,
          mode: 'cors',
          credentials: 'include'
        };
      },
      /**
       * Unpack payload from response, resolve/reject deferred
       * @function unpack
       * @param {Object} response - response
       * @param {Deferred} deferred - promise
       * @param {Object} options - options
       * @return {Promise} payload - promise
       * */
      unpack: function unpack(response) {
        return response.json().then(function checkSuccess(res) {
          if (res.success === 'TRUE') {
            return res;
          }
          return Promise.reject(res.payload.error);
        });
      }
    };

    return jsonPackager;
  }

  return new RiqApiFormatter();
});
